<pbc-filter [config]="FormulareFilterConfig" [filter]="formulare.filter$ | async" (filterChange)="formulare.filter$.next($event)"></pbc-filter>
